import React, {Fragment} from "react";
import {msgSource} from "_constants";
import ZendeskSetting from "./Zendesk/ZendeskSetting";
import GorgiasSettings from "./Gorgias/GorgiasSettings";

export default function MsgDataSourceDetails({msgSourceProp, mode, label}) {
    const msgSourceName = _.toString(msgSourceProp?.name).toLowerCase();
    const msgDataSources = msgSourceProp?.msgDataSources;

    switch (msgSourceName) {
        case msgSource.ZENDESK:
            return <ZendeskSetting msgDataSources={msgDataSources} mode={mode} label={label}/>

        case msgSource.GORGIAS:
            return <GorgiasSettings msgDataSources={msgDataSources} mode={mode} label={label}/>

        default:
            return <Fragment/>

    }
}